import { ExtendedLink, Link, TrackingData } from '@ecm/router';

import { TypeEnum } from '../../api/dashboardV7/push/typeEnum';
import { ButtonViewModel } from './button.view-model';

export class PushV7ViewModel {
    public advTracker?: string;
    public alt?: string;
    public button?: ButtonViewModel;
    public category?: string;
    public cid?: string;
    public code?: string;
    public content?: Array<string> | string;
    public idRefZone?: string;
    public imageUrl?: string;
    public label?: string;
    public link?: Link;
    public extendedLink?: ExtendedLink;
    public secondaryCode?: any;
    public text?: string;
    public title?: string;
    public trackingData?: TrackingData;
    public type: TypeEnum;
    public urlLabel?: any;
}
